import React from 'react';
import { format, parseISO, isValid } from 'date-fns';
import styles from './styles.module.scss';
import Flex from 'src/components/Flex';
import Card from 'src/components/Card';
import { IntegrationMigrationInfo } from 'src/api/surveyIntegration';

interface MigrationInfoSectionProps {
    migrationInfo: IntegrationMigrationInfo;
}

function formatCompletedAt(value: string | null): string {
    if (!value) return '—';
    const date = parseISO(value);
    return isValid(date) ? format(date, "MMM d, yyyy 'at' h:mm a") : '—';
}

function MigrationInfoSection({ migrationInfo }: MigrationInfoSectionProps) {
    return (
        <Card className={styles.cardWrap} label="Migration Info">
            <Flex direction="column" className={styles.sectionBody}>
                <table className={styles.infoTable}>
                    <tbody>
                        <tr>
                            <th>Migration completed</th>
                            <td>{formatCompletedAt(migrationInfo.completedAt)}</td>
                        </tr>
                        <tr>
                            <th>Surveys migrated</th>
                            <td>{migrationInfo.surveysMigrated.toLocaleString()}</td>
                        </tr>
                        <tr>
                            <th>Template</th>
                            <td>{migrationInfo.templateName ?? '—'}</td>
                        </tr>
                    </tbody>
                </table>
            </Flex>
        </Card>
    );
}

export default MigrationInfoSection;
